import Price from 'components/price';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import MbvModal from './mbv-modal';

interface PropTypes {
  insufficientMoney: number;
}

const MinimumBasketValueNotice: React.FC<PropTypes> = ({ insufficientMoney }) => {
  const [isMbvModalVisible, setIsMbvModalVisible] = useState(false);
  const onCloseModal = useCallback(() => setIsMbvModalVisible(false), []);

  return (
    <>
      <MbvModal
        isOpen={isMbvModalVisible}
        insufficientMoney={insufficientMoney}
        onClose={onCloseModal}
      />
      <div
        data-test="mov-modal"
        className="mt-4 flex justify-between rounded-sm border border-red-300 bg-red-100 px-3 pt-3 pb-2 text-base leading-tight"
      >
        <div data-test="mov-message" className="pr-2">
          <FormattedMessage id="cart:mbv:notice-text" />
        </div>
        <span data-test="mov-insufficientMoney">
          <Price value={insufficientMoney} />
        </span>
      </div>
    </>
  );
};

export default MinimumBasketValueNotice;
